/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * API specification
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AdminMailComposeInput,
  AdminMailError,
  AdminMailListResponse,
  AdminMailSendResponse,
  AutoQuoteExampleList,
  CostRecipeInput,
  CostRecipeState,
  CostTaskFavouriteInput,
  CostTaskFavouriteRef,
  GetAdminMailParams,
  HealthStatus,
  NavigationHeadingNameEdit,
  PasswordResetConfirmInput,
  PasswordResetMessage,
  PasswordResetRequestInput,
  PdfArtworkInput,
  PdfArtworkPair,
  PdfLogoAsset,
  PdfLogoUpload,
  PdfTemplateApplied,
  PdfTemplateInput,
  PdfTemplateSelection,
  PdfTemplateState,
  PriceResearchDocument,
  PriceResearchInput,
  QuoteGenerationRecovery,
  QuoteHeadingPreferences,
  QuoteMaterialsProposal,
  QuoteMaterialsProposalRequest,
  RecipeDraftApprovalInput,
  RecipeDraftApprovalResult,
  RecipeDraftBaselineInput,
  RecipeDraftDetail,
  RecipeDraftEditInput,
  RecipeDraftList,
  RecipeDraftQueued,
  RecipeDraftSafety,
  RecipeDraftSaved,
  RecipeDraftSkipInput,
  RecipeDraftStartInput,
  RecipeRedraftInput,
  SubscriptionTransferDestination,
  SubscriptionTransferInput,
  SubscriptionTransferPreview,
  SubscriptionTransferResult,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Recover this account's completed quote after a disconnected response
 */
export const getGetQuoteGenerationResultUrl = (requestId: string) => {
  return `/api/quote-generation-results/${requestId}`;
};

export const getQuoteGenerationResult = async (
  requestId: string,
  options?: RequestInit,
): Promise<QuoteGenerationRecovery> => {
  return customFetch<QuoteGenerationRecovery>(
    getGetQuoteGenerationResultUrl(requestId),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetQuoteGenerationResultQueryKey = (requestId: string) => {
  return [`/api/quote-generation-results/${requestId}`] as const;
};

export const getGetQuoteGenerationResultQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuoteGenerationResult>>,
  TError = ErrorType<void>,
>(
  requestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteGenerationResult>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuoteGenerationResultQueryKey(requestId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuoteGenerationResult>>
  > = ({ signal }) =>
    getQuoteGenerationResult(requestId, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!requestId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteGenerationResult>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuoteGenerationResultQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuoteGenerationResult>>
>;
export type GetQuoteGenerationResultQueryError = ErrorType<void>;

/**
 * @summary Recover this account's completed quote after a disconnected response
 */

export function useGetQuoteGenerationResult<
  TData = Awaited<ReturnType<typeof getQuoteGenerationResult>>,
  TError = ErrorType<void>,
>(
  requestId: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getQuoteGenerationResult>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuoteGenerationResultQueryOptions(
    requestId,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Resolve quote-local purchase materials automatically without changing quoted prices
 */
export const getProposeQuoteMaterialsUrl = () => {
  return `/api/quotes/materials/proposal`;
};

export const proposeQuoteMaterials = async (
  quoteMaterialsProposalRequest: QuoteMaterialsProposalRequest,
  options?: RequestInit,
): Promise<QuoteMaterialsProposal> => {
  return customFetch<QuoteMaterialsProposal>(getProposeQuoteMaterialsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(quoteMaterialsProposalRequest),
  });
};

export const getProposeQuoteMaterialsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proposeQuoteMaterials>>,
    TError,
    { data: BodyType<QuoteMaterialsProposalRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof proposeQuoteMaterials>>,
  TError,
  { data: BodyType<QuoteMaterialsProposalRequest> },
  TContext
> => {
  const mutationKey = ["proposeQuoteMaterials"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof proposeQuoteMaterials>>,
    { data: BodyType<QuoteMaterialsProposalRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return proposeQuoteMaterials(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ProposeQuoteMaterialsMutationResult = NonNullable<
  Awaited<ReturnType<typeof proposeQuoteMaterials>>
>;
export type ProposeQuoteMaterialsMutationBody =
  BodyType<QuoteMaterialsProposalRequest>;
export type ProposeQuoteMaterialsMutationError = ErrorType<void>;

/**
 * @summary Resolve quote-local purchase materials automatically without changing quoted prices
 */
export const useProposeQuoteMaterials = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof proposeQuoteMaterials>>,
    TError,
    { data: BodyType<QuoteMaterialsProposalRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof proposeQuoteMaterials>>,
  TError,
  { data: BodyType<QuoteMaterialsProposalRequest> },
  TContext
> => {
  return useMutation(getProposeQuoteMaterialsMutationOptions(options));
};

export const getListPriceResearchUrl = () => {
  return `/api/admin/cost-library/price-review`;
};

export const listPriceResearch = async (
  options?: RequestInit,
): Promise<PriceResearchDocument> => {
  return customFetch<PriceResearchDocument>(getListPriceResearchUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListPriceResearchQueryKey = () => {
  return [`/api/admin/cost-library/price-review`] as const;
};

export const getListPriceResearchQueryOptions = <
  TData = Awaited<ReturnType<typeof listPriceResearch>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPriceResearch>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListPriceResearchQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listPriceResearch>>
  > = ({ signal }) => listPriceResearch({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listPriceResearch>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListPriceResearchQueryResult = NonNullable<
  Awaited<ReturnType<typeof listPriceResearch>>
>;
export type ListPriceResearchQueryError = ErrorType<unknown>;

export function useListPriceResearch<
  TData = Awaited<ReturnType<typeof listPriceResearch>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listPriceResearch>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListPriceResearchQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getActOnPriceResearchUrl = () => {
  return `/api/admin/cost-library/price-review`;
};

export const actOnPriceResearch = async (
  priceResearchInput: PriceResearchInput,
  options?: RequestInit,
): Promise<PriceResearchDocument> => {
  return customFetch<PriceResearchDocument>(getActOnPriceResearchUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(priceResearchInput),
  });
};

export const getActOnPriceResearchMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof actOnPriceResearch>>,
    TError,
    { data: BodyType<PriceResearchInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof actOnPriceResearch>>,
  TError,
  { data: BodyType<PriceResearchInput> },
  TContext
> => {
  const mutationKey = ["actOnPriceResearch"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof actOnPriceResearch>>,
    { data: BodyType<PriceResearchInput> }
  > = (props) => {
    const { data } = props ?? {};

    return actOnPriceResearch(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ActOnPriceResearchMutationResult = NonNullable<
  Awaited<ReturnType<typeof actOnPriceResearch>>
>;
export type ActOnPriceResearchMutationBody = BodyType<PriceResearchInput>;
export type ActOnPriceResearchMutationError = ErrorType<unknown>;

export const useActOnPriceResearch = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof actOnPriceResearch>>,
    TError,
    { data: BodyType<PriceResearchInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof actOnPriceResearch>>,
  TError,
  { data: BodyType<PriceResearchInput> },
  TContext
> => {
  return useMutation(getActOnPriceResearchMutationOptions(options));
};

export const getGetCostTaskFavouritesUrl = () => {
  return `/api/cost-library/favourites`;
};

export const getCostTaskFavourites = async (
  options?: RequestInit,
): Promise<CostTaskFavouriteRef[]> => {
  return customFetch<CostTaskFavouriteRef[]>(getGetCostTaskFavouritesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetCostTaskFavouritesQueryKey = () => {
  return [`/api/cost-library/favourites`] as const;
};

export const getGetCostTaskFavouritesQueryOptions = <
  TData = Awaited<ReturnType<typeof getCostTaskFavourites>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCostTaskFavourites>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCostTaskFavouritesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCostTaskFavourites>>
  > = ({ signal }) => getCostTaskFavourites({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCostTaskFavourites>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCostTaskFavouritesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCostTaskFavourites>>
>;
export type GetCostTaskFavouritesQueryError = ErrorType<unknown>;

export function useGetCostTaskFavourites<
  TData = Awaited<ReturnType<typeof getCostTaskFavourites>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getCostTaskFavourites>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCostTaskFavouritesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSetCostTaskFavouriteUrl = () => {
  return `/api/cost-library/favourites`;
};

export const setCostTaskFavourite = async (
  costTaskFavouriteInput: CostTaskFavouriteInput,
  options?: RequestInit,
): Promise<void> => {
  return customFetch<void>(getSetCostTaskFavouriteUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(costTaskFavouriteInput),
  });
};

export const getSetCostTaskFavouriteMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCostTaskFavourite>>,
    TError,
    { data: BodyType<CostTaskFavouriteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setCostTaskFavourite>>,
  TError,
  { data: BodyType<CostTaskFavouriteInput> },
  TContext
> => {
  const mutationKey = ["setCostTaskFavourite"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setCostTaskFavourite>>,
    { data: BodyType<CostTaskFavouriteInput> }
  > = (props) => {
    const { data } = props ?? {};

    return setCostTaskFavourite(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetCostTaskFavouriteMutationResult = NonNullable<
  Awaited<ReturnType<typeof setCostTaskFavourite>>
>;
export type SetCostTaskFavouriteMutationBody = BodyType<CostTaskFavouriteInput>;
export type SetCostTaskFavouriteMutationError = ErrorType<void>;

export const useSetCostTaskFavourite = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCostTaskFavourite>>,
    TError,
    { data: BodyType<CostTaskFavouriteInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setCostTaskFavourite>>,
  TError,
  { data: BodyType<CostTaskFavouriteInput> },
  TContext
> => {
  return useMutation(getSetCostTaskFavouriteMutationOptions(options));
};

export const getListRecipeDraftsUrl = () => {
  return `/api/admin/cost-library/recipe-drafts`;
};

export const listRecipeDrafts = async (
  options?: RequestInit,
): Promise<RecipeDraftList> => {
  return customFetch<RecipeDraftList>(getListRecipeDraftsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListRecipeDraftsQueryKey = () => {
  return [`/api/admin/cost-library/recipe-drafts`] as const;
};

export const getListRecipeDraftsQueryOptions = <
  TData = Awaited<ReturnType<typeof listRecipeDrafts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listRecipeDrafts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListRecipeDraftsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listRecipeDrafts>>
  > = ({ signal }) => listRecipeDrafts({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listRecipeDrafts>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListRecipeDraftsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listRecipeDrafts>>
>;
export type ListRecipeDraftsQueryError = ErrorType<unknown>;

export function useListRecipeDrafts<
  TData = Awaited<ReturnType<typeof listRecipeDrafts>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listRecipeDrafts>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListRecipeDraftsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getStartRecipeDraftsUrl = () => {
  return `/api/admin/cost-library/recipe-drafts/start`;
};

export const startRecipeDrafts = async (
  recipeDraftStartInput: RecipeDraftStartInput,
  options?: RequestInit,
): Promise<RecipeDraftQueued> => {
  return customFetch<RecipeDraftQueued>(getStartRecipeDraftsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recipeDraftStartInput),
  });
};

export const getStartRecipeDraftsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startRecipeDrafts>>,
    TError,
    { data: BodyType<RecipeDraftStartInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startRecipeDrafts>>,
  TError,
  { data: BodyType<RecipeDraftStartInput> },
  TContext
> => {
  const mutationKey = ["startRecipeDrafts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startRecipeDrafts>>,
    { data: BodyType<RecipeDraftStartInput> }
  > = (props) => {
    const { data } = props ?? {};

    return startRecipeDrafts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type StartRecipeDraftsMutationResult = NonNullable<
  Awaited<ReturnType<typeof startRecipeDrafts>>
>;
export type StartRecipeDraftsMutationBody = BodyType<RecipeDraftStartInput>;
export type StartRecipeDraftsMutationError = ErrorType<unknown>;

export const useStartRecipeDrafts = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startRecipeDrafts>>,
    TError,
    { data: BodyType<RecipeDraftStartInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof startRecipeDrafts>>,
  TError,
  { data: BodyType<RecipeDraftStartInput> },
  TContext
> => {
  return useMutation(getStartRecipeDraftsMutationOptions(options));
};

export const getRefreshRecipeDraftBaselineUrl = () => {
  return `/api/admin/cost-library/recipe-drafts/baseline`;
};

export const refreshRecipeDraftBaseline = async (
  recipeDraftBaselineInput: RecipeDraftBaselineInput,
  options?: RequestInit,
): Promise<RecipeDraftSafety> => {
  return customFetch<RecipeDraftSafety>(getRefreshRecipeDraftBaselineUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recipeDraftBaselineInput),
  });
};

export const getRefreshRecipeDraftBaselineMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshRecipeDraftBaseline>>,
    TError,
    { data: BodyType<RecipeDraftBaselineInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof refreshRecipeDraftBaseline>>,
  TError,
  { data: BodyType<RecipeDraftBaselineInput> },
  TContext
> => {
  const mutationKey = ["refreshRecipeDraftBaseline"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof refreshRecipeDraftBaseline>>,
    { data: BodyType<RecipeDraftBaselineInput> }
  > = (props) => {
    const { data } = props ?? {};

    return refreshRecipeDraftBaseline(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RefreshRecipeDraftBaselineMutationResult = NonNullable<
  Awaited<ReturnType<typeof refreshRecipeDraftBaseline>>
>;
export type RefreshRecipeDraftBaselineMutationBody =
  BodyType<RecipeDraftBaselineInput>;
export type RefreshRecipeDraftBaselineMutationError = ErrorType<unknown>;

export const useRefreshRecipeDraftBaseline = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof refreshRecipeDraftBaseline>>,
    TError,
    { data: BodyType<RecipeDraftBaselineInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof refreshRecipeDraftBaseline>>,
  TError,
  { data: BodyType<RecipeDraftBaselineInput> },
  TContext
> => {
  return useMutation(getRefreshRecipeDraftBaselineMutationOptions(options));
};

export const getApproveRecipeDraftsUrl = () => {
  return `/api/admin/cost-library/recipe-drafts/approve`;
};

export const approveRecipeDrafts = async (
  recipeDraftApprovalInput: RecipeDraftApprovalInput,
  options?: RequestInit,
): Promise<RecipeDraftApprovalResult> => {
  return customFetch<RecipeDraftApprovalResult>(getApproveRecipeDraftsUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recipeDraftApprovalInput),
  });
};

export const getApproveRecipeDraftsMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveRecipeDrafts>>,
    TError,
    { data: BodyType<RecipeDraftApprovalInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof approveRecipeDrafts>>,
  TError,
  { data: BodyType<RecipeDraftApprovalInput> },
  TContext
> => {
  const mutationKey = ["approveRecipeDrafts"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof approveRecipeDrafts>>,
    { data: BodyType<RecipeDraftApprovalInput> }
  > = (props) => {
    const { data } = props ?? {};

    return approveRecipeDrafts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApproveRecipeDraftsMutationResult = NonNullable<
  Awaited<ReturnType<typeof approveRecipeDrafts>>
>;
export type ApproveRecipeDraftsMutationBody =
  BodyType<RecipeDraftApprovalInput>;
export type ApproveRecipeDraftsMutationError = ErrorType<void>;

export const useApproveRecipeDrafts = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof approveRecipeDrafts>>,
    TError,
    { data: BodyType<RecipeDraftApprovalInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof approveRecipeDrafts>>,
  TError,
  { data: BodyType<RecipeDraftApprovalInput> },
  TContext
> => {
  return useMutation(getApproveRecipeDraftsMutationOptions(options));
};

export const getGetRecipeDraftUrl = (id: string) => {
  return `/api/admin/cost-library/recipe-drafts/${id}`;
};

export const getRecipeDraft = async (
  id: string,
  options?: RequestInit,
): Promise<RecipeDraftDetail> => {
  return customFetch<RecipeDraftDetail>(getGetRecipeDraftUrl(id), {
    ...options,
    method: "GET",
  });
};

export const getGetRecipeDraftQueryKey = (id: string) => {
  return [`/api/admin/cost-library/recipe-drafts/${id}`] as const;
};

export const getGetRecipeDraftQueryOptions = <
  TData = Awaited<ReturnType<typeof getRecipeDraft>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecipeDraft>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetRecipeDraftQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getRecipeDraft>>> = ({
    signal,
  }) => getRecipeDraft(id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRecipeDraft>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRecipeDraftQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRecipeDraft>>
>;
export type GetRecipeDraftQueryError = ErrorType<unknown>;

export function useGetRecipeDraft<
  TData = Awaited<ReturnType<typeof getRecipeDraft>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getRecipeDraft>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetRecipeDraftQueryOptions(id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSaveRecipeDraftUrl = (id: string) => {
  return `/api/admin/cost-library/recipe-drafts/${id}`;
};

export const saveRecipeDraft = async (
  id: string,
  recipeDraftEditInput: RecipeDraftEditInput,
  options?: RequestInit,
): Promise<RecipeDraftSaved> => {
  return customFetch<RecipeDraftSaved>(getSaveRecipeDraftUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recipeDraftEditInput),
  });
};

export const getSaveRecipeDraftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveRecipeDraft>>,
    TError,
    { id: string; data: BodyType<RecipeDraftEditInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveRecipeDraft>>,
  TError,
  { id: string; data: BodyType<RecipeDraftEditInput> },
  TContext
> => {
  const mutationKey = ["saveRecipeDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveRecipeDraft>>,
    { id: string; data: BodyType<RecipeDraftEditInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return saveRecipeDraft(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveRecipeDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveRecipeDraft>>
>;
export type SaveRecipeDraftMutationBody = BodyType<RecipeDraftEditInput>;
export type SaveRecipeDraftMutationError = ErrorType<unknown>;

export const useSaveRecipeDraft = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveRecipeDraft>>,
    TError,
    { id: string; data: BodyType<RecipeDraftEditInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveRecipeDraft>>,
  TError,
  { id: string; data: BodyType<RecipeDraftEditInput> },
  TContext
> => {
  return useMutation(getSaveRecipeDraftMutationOptions(options));
};

export const getRedraftCostRecipeUrl = (id: string) => {
  return `/api/admin/cost-library/recipe-drafts/${id}/redraft`;
};

export const redraftCostRecipe = async (
  id: string,
  recipeRedraftInput: RecipeRedraftInput,
  options?: RequestInit,
): Promise<RecipeDraftSaved> => {
  return customFetch<RecipeDraftSaved>(getRedraftCostRecipeUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recipeRedraftInput),
  });
};

export const getRedraftCostRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redraftCostRecipe>>,
    TError,
    { id: string; data: BodyType<RecipeRedraftInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof redraftCostRecipe>>,
  TError,
  { id: string; data: BodyType<RecipeRedraftInput> },
  TContext
> => {
  const mutationKey = ["redraftCostRecipe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof redraftCostRecipe>>,
    { id: string; data: BodyType<RecipeRedraftInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return redraftCostRecipe(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RedraftCostRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof redraftCostRecipe>>
>;
export type RedraftCostRecipeMutationBody = BodyType<RecipeRedraftInput>;
export type RedraftCostRecipeMutationError = ErrorType<unknown>;

export const useRedraftCostRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof redraftCostRecipe>>,
    TError,
    { id: string; data: BodyType<RecipeRedraftInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof redraftCostRecipe>>,
  TError,
  { id: string; data: BodyType<RecipeRedraftInput> },
  TContext
> => {
  return useMutation(getRedraftCostRecipeMutationOptions(options));
};

export const getSkipRecipeDraftUrl = (id: string) => {
  return `/api/admin/cost-library/recipe-drafts/${id}/skip`;
};

export const skipRecipeDraft = async (
  id: string,
  recipeDraftSkipInput: RecipeDraftSkipInput,
  options?: RequestInit,
): Promise<RecipeDraftSaved> => {
  return customFetch<RecipeDraftSaved>(getSkipRecipeDraftUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(recipeDraftSkipInput),
  });
};

export const getSkipRecipeDraftMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skipRecipeDraft>>,
    TError,
    { id: string; data: BodyType<RecipeDraftSkipInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof skipRecipeDraft>>,
  TError,
  { id: string; data: BodyType<RecipeDraftSkipInput> },
  TContext
> => {
  const mutationKey = ["skipRecipeDraft"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof skipRecipeDraft>>,
    { id: string; data: BodyType<RecipeDraftSkipInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return skipRecipeDraft(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SkipRecipeDraftMutationResult = NonNullable<
  Awaited<ReturnType<typeof skipRecipeDraft>>
>;
export type SkipRecipeDraftMutationBody = BodyType<RecipeDraftSkipInput>;
export type SkipRecipeDraftMutationError = ErrorType<unknown>;

export const useSkipRecipeDraft = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof skipRecipeDraft>>,
    TError,
    { id: string; data: BodyType<RecipeDraftSkipInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof skipRecipeDraft>>,
  TError,
  { id: string; data: BodyType<RecipeDraftSkipInput> },
  TContext
> => {
  return useMutation(getSkipRecipeDraftMutationOptions(options));
};

export const getGetCostRecipeUrl = (
  source: "default" | "custom",
  id: string,
) => {
  return `/api/cost-library/recipes/${source}/${id}`;
};

export const getCostRecipe = async (
  source: "default" | "custom",
  id: string,
  options?: RequestInit,
): Promise<CostRecipeState> => {
  return customFetch<CostRecipeState>(getGetCostRecipeUrl(source, id), {
    ...options,
    method: "GET",
  });
};

export const getGetCostRecipeQueryKey = (
  source: "default" | "custom",
  id: string,
) => {
  return [`/api/cost-library/recipes/${source}/${id}`] as const;
};

export const getGetCostRecipeQueryOptions = <
  TData = Awaited<ReturnType<typeof getCostRecipe>>,
  TError = ErrorType<unknown>,
>(
  source: "default" | "custom",
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCostRecipe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCostRecipeQueryKey(source, id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCostRecipe>>> = ({
    signal,
  }) => getCostRecipe(source, id, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!(source && id),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCostRecipe>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCostRecipeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCostRecipe>>
>;
export type GetCostRecipeQueryError = ErrorType<unknown>;

export function useGetCostRecipe<
  TData = Awaited<ReturnType<typeof getCostRecipe>>,
  TError = ErrorType<unknown>,
>(
  source: "default" | "custom",
  id: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCostRecipe>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCostRecipeQueryOptions(source, id, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSaveCostRecipeUrl = (
  source: "default" | "custom",
  id: string,
) => {
  return `/api/cost-library/recipes/${source}/${id}`;
};

export const saveCostRecipe = async (
  source: "default" | "custom",
  id: string,
  costRecipeInput: CostRecipeInput,
  options?: RequestInit,
): Promise<CostRecipeState> => {
  return customFetch<CostRecipeState>(getSaveCostRecipeUrl(source, id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(costRecipeInput),
  });
};

export const getSaveCostRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCostRecipe>>,
    TError,
    {
      source: "default" | "custom";
      id: string;
      data: BodyType<CostRecipeInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveCostRecipe>>,
  TError,
  { source: "default" | "custom"; id: string; data: BodyType<CostRecipeInput> },
  TContext
> => {
  const mutationKey = ["saveCostRecipe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveCostRecipe>>,
    {
      source: "default" | "custom";
      id: string;
      data: BodyType<CostRecipeInput>;
    }
  > = (props) => {
    const { source, id, data } = props ?? {};

    return saveCostRecipe(source, id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveCostRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveCostRecipe>>
>;
export type SaveCostRecipeMutationBody = BodyType<CostRecipeInput>;
export type SaveCostRecipeMutationError = ErrorType<unknown>;

export const useSaveCostRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveCostRecipe>>,
    TError,
    {
      source: "default" | "custom";
      id: string;
      data: BodyType<CostRecipeInput>;
    },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveCostRecipe>>,
  TError,
  { source: "default" | "custom"; id: string; data: BodyType<CostRecipeInput> },
  TContext
> => {
  return useMutation(getSaveCostRecipeMutationOptions(options));
};

export const getResetCostRecipeUrl = (
  source: "default" | "custom",
  id: string,
) => {
  return `/api/cost-library/recipes/${source}/${id}`;
};

export const resetCostRecipe = async (
  source: "default" | "custom",
  id: string,
  options?: RequestInit,
): Promise<CostRecipeState> => {
  return customFetch<CostRecipeState>(getResetCostRecipeUrl(source, id), {
    ...options,
    method: "DELETE",
  });
};

export const getResetCostRecipeMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCostRecipe>>,
    TError,
    { source: "default" | "custom"; id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resetCostRecipe>>,
  TError,
  { source: "default" | "custom"; id: string },
  TContext
> => {
  const mutationKey = ["resetCostRecipe"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resetCostRecipe>>,
    { source: "default" | "custom"; id: string }
  > = (props) => {
    const { source, id } = props ?? {};

    return resetCostRecipe(source, id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResetCostRecipeMutationResult = NonNullable<
  Awaited<ReturnType<typeof resetCostRecipe>>
>;

export type ResetCostRecipeMutationError = ErrorType<unknown>;

export const useResetCostRecipe = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resetCostRecipe>>,
    TError,
    { source: "default" | "custom"; id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resetCostRecipe>>,
  TError,
  { source: "default" | "custom"; id: string },
  TContext
> => {
  return useMutation(getResetCostRecipeMutationOptions(options));
};

/**
 * Requires a signed-in builder-product administrator. Serves only the indexed server-stored quote-analysis upload, including legacy files without owner ACLs.
 */
export const getDownloadAdminGeneratedQuoteFileUrl = (
  id: string,
  fileIndex: number,
) => {
  return `/api/admin/generated-quotes/${id}/files/${fileIndex}`;
};

export const downloadAdminGeneratedQuoteFile = async (
  id: string,
  fileIndex: number,
  options?: RequestInit,
): Promise<Blob> => {
  return customFetch<Blob>(
    getDownloadAdminGeneratedQuoteFileUrl(id, fileIndex),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getDownloadAdminGeneratedQuoteFileQueryKey = (
  id: string,
  fileIndex: number,
) => {
  return [`/api/admin/generated-quotes/${id}/files/${fileIndex}`] as const;
};

export const getDownloadAdminGeneratedQuoteFileQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadAdminGeneratedQuoteFile>>,
  TError = ErrorType<void>,
>(
  id: string,
  fileIndex: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadAdminGeneratedQuoteFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getDownloadAdminGeneratedQuoteFileQueryKey(id, fileIndex);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadAdminGeneratedQuoteFile>>
  > = ({ signal }) =>
    downloadAdminGeneratedQuoteFile(id, fileIndex, {
      signal,
      ...requestOptions,
    });

  return {
    queryKey,
    queryFn,
    enabled: !!(id && fileIndex),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadAdminGeneratedQuoteFile>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadAdminGeneratedQuoteFileQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadAdminGeneratedQuoteFile>>
>;
export type DownloadAdminGeneratedQuoteFileQueryError = ErrorType<void>;

export function useDownloadAdminGeneratedQuoteFile<
  TData = Awaited<ReturnType<typeof downloadAdminGeneratedQuoteFile>>,
  TError = ErrorType<void>,
>(
  id: string,
  fileIndex: number,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof downloadAdminGeneratedQuoteFile>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getDownloadAdminGeneratedQuoteFileQueryOptions(
    id,
    fileIndex,
    options,
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getGetPdfTemplateUrl = () => {
  return `/api/pdf-template`;
};

export const getPdfTemplate = async (
  options?: RequestInit,
): Promise<PdfTemplateState> => {
  return customFetch<PdfTemplateState>(getGetPdfTemplateUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetPdfTemplateQueryKey = () => {
  return [`/api/pdf-template`] as const;
};

export const getGetPdfTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getPdfTemplate>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPdfTemplate>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPdfTemplateQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPdfTemplate>>> = ({
    signal,
  }) => getPdfTemplate({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPdfTemplate>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPdfTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPdfTemplate>>
>;
export type GetPdfTemplateQueryError = ErrorType<unknown>;

export function useGetPdfTemplate<
  TData = Awaited<ReturnType<typeof getPdfTemplate>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getPdfTemplate>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetPdfTemplateQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSavePdfTemplateUrl = () => {
  return `/api/pdf-template`;
};

export const savePdfTemplate = async (
  pdfTemplateInput: PdfTemplateInput,
  options?: RequestInit,
): Promise<PdfTemplateState> => {
  return customFetch<PdfTemplateState>(getSavePdfTemplateUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(pdfTemplateInput),
  });
};

export const getSavePdfTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savePdfTemplate>>,
    TError,
    { data: BodyType<PdfTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof savePdfTemplate>>,
  TError,
  { data: BodyType<PdfTemplateInput> },
  TContext
> => {
  const mutationKey = ["savePdfTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof savePdfTemplate>>,
    { data: BodyType<PdfTemplateInput> }
  > = (props) => {
    const { data } = props ?? {};

    return savePdfTemplate(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SavePdfTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof savePdfTemplate>>
>;
export type SavePdfTemplateMutationBody = BodyType<PdfTemplateInput>;
export type SavePdfTemplateMutationError = ErrorType<unknown>;

export const useSavePdfTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof savePdfTemplate>>,
    TError,
    { data: BodyType<PdfTemplateInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof savePdfTemplate>>,
  TError,
  { data: BodyType<PdfTemplateInput> },
  TContext
> => {
  return useMutation(getSavePdfTemplateMutationOptions(options));
};

export const getGeneratePdfTemplateArtworkUrl = () => {
  return `/api/pdf-template/artwork`;
};

export const generatePdfTemplateArtwork = async (
  pdfArtworkInput: PdfArtworkInput,
  options?: RequestInit,
): Promise<PdfArtworkPair> => {
  return customFetch<PdfArtworkPair>(getGeneratePdfTemplateArtworkUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(pdfArtworkInput),
  });
};

export const getGeneratePdfTemplateArtworkMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePdfTemplateArtwork>>,
    TError,
    { data: BodyType<PdfArtworkInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof generatePdfTemplateArtwork>>,
  TError,
  { data: BodyType<PdfArtworkInput> },
  TContext
> => {
  const mutationKey = ["generatePdfTemplateArtwork"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof generatePdfTemplateArtwork>>,
    { data: BodyType<PdfArtworkInput> }
  > = (props) => {
    const { data } = props ?? {};

    return generatePdfTemplateArtwork(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type GeneratePdfTemplateArtworkMutationResult = NonNullable<
  Awaited<ReturnType<typeof generatePdfTemplateArtwork>>
>;
export type GeneratePdfTemplateArtworkMutationBody = BodyType<PdfArtworkInput>;
export type GeneratePdfTemplateArtworkMutationError = ErrorType<void>;

export const useGeneratePdfTemplateArtwork = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof generatePdfTemplateArtwork>>,
    TError,
    { data: BodyType<PdfArtworkInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof generatePdfTemplateArtwork>>,
  TError,
  { data: BodyType<PdfArtworkInput> },
  TContext
> => {
  return useMutation(getGeneratePdfTemplateArtworkMutationOptions(options));
};

export const getUploadPdfTemplateLogoUrl = () => {
  return `/api/pdf-template/logo`;
};

export const uploadPdfTemplateLogo = async (
  pdfLogoUpload: PdfLogoUpload,
  options?: RequestInit,
): Promise<PdfLogoAsset> => {
  return customFetch<PdfLogoAsset>(getUploadPdfTemplateLogoUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(pdfLogoUpload),
  });
};

export const getUploadPdfTemplateLogoMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPdfTemplateLogo>>,
    TError,
    { data: BodyType<PdfLogoUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof uploadPdfTemplateLogo>>,
  TError,
  { data: BodyType<PdfLogoUpload> },
  TContext
> => {
  const mutationKey = ["uploadPdfTemplateLogo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof uploadPdfTemplateLogo>>,
    { data: BodyType<PdfLogoUpload> }
  > = (props) => {
    const { data } = props ?? {};

    return uploadPdfTemplateLogo(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UploadPdfTemplateLogoMutationResult = NonNullable<
  Awaited<ReturnType<typeof uploadPdfTemplateLogo>>
>;
export type UploadPdfTemplateLogoMutationBody = BodyType<PdfLogoUpload>;
export type UploadPdfTemplateLogoMutationError = ErrorType<unknown>;

export const useUploadPdfTemplateLogo = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof uploadPdfTemplateLogo>>,
    TError,
    { data: BodyType<PdfLogoUpload> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof uploadPdfTemplateLogo>>,
  TError,
  { data: BodyType<PdfLogoUpload> },
  TContext
> => {
  return useMutation(getUploadPdfTemplateLogoMutationOptions(options));
};

export const getApplyQuotePdfTemplateUrl = (id: string) => {
  return `/api/quotes/${id}/pdf-template`;
};

export const applyQuotePdfTemplate = async (
  id: string,
  pdfTemplateSelection: PdfTemplateSelection,
  options?: RequestInit,
): Promise<PdfTemplateApplied> => {
  return customFetch<PdfTemplateApplied>(getApplyQuotePdfTemplateUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(pdfTemplateSelection),
  });
};

export const getApplyQuotePdfTemplateMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyQuotePdfTemplate>>,
    TError,
    { id: string; data: BodyType<PdfTemplateSelection> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof applyQuotePdfTemplate>>,
  TError,
  { id: string; data: BodyType<PdfTemplateSelection> },
  TContext
> => {
  const mutationKey = ["applyQuotePdfTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof applyQuotePdfTemplate>>,
    { id: string; data: BodyType<PdfTemplateSelection> }
  > = (props) => {
    const { id, data } = props ?? {};

    return applyQuotePdfTemplate(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ApplyQuotePdfTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof applyQuotePdfTemplate>>
>;
export type ApplyQuotePdfTemplateMutationBody = BodyType<PdfTemplateSelection>;
export type ApplyQuotePdfTemplateMutationError = ErrorType<unknown>;

export const useApplyQuotePdfTemplate = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof applyQuotePdfTemplate>>,
    TError,
    { id: string; data: BodyType<PdfTemplateSelection> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof applyQuotePdfTemplate>>,
  TError,
  { id: string; data: BodyType<PdfTemplateSelection> },
  TContext
> => {
  return useMutation(getApplyQuotePdfTemplateMutationOptions(options));
};

/**
 * @summary Quote examples with illustrative identities, verified quoting methods and measured timings
 */
export const getGetAutoQuoteExamplesUrl = () => {
  return `/api/public/auto-quote-examples`;
};

export const getAutoQuoteExamples = async (
  options?: RequestInit,
): Promise<AutoQuoteExampleList> => {
  return customFetch<AutoQuoteExampleList>(getGetAutoQuoteExamplesUrl(), {
    ...options,
    method: "GET",
  });
};

export const getGetAutoQuoteExamplesQueryKey = () => {
  return [`/api/public/auto-quote-examples`] as const;
};

export const getGetAutoQuoteExamplesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAutoQuoteExamples>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAutoQuoteExamples>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAutoQuoteExamplesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAutoQuoteExamples>>
  > = ({ signal }) => getAutoQuoteExamples({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAutoQuoteExamples>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAutoQuoteExamplesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAutoQuoteExamples>>
>;
export type GetAutoQuoteExamplesQueryError = ErrorType<void>;

/**
 * @summary Quote examples with illustrative identities, verified quoting methods and measured timings
 */

export function useGetAutoQuoteExamples<
  TData = Awaited<ReturnType<typeof getAutoQuoteExamples>>,
  TError = ErrorType<void>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getAutoQuoteExamples>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAutoQuoteExamplesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Rename or reset one Cost Library navigation entry
 */
export const getPatchQuoteHeadingNameUrl = () => {
  return `/api/quote-heading-preferences`;
};

export const patchQuoteHeadingName = async (
  navigationHeadingNameEdit: NavigationHeadingNameEdit,
  options?: RequestInit,
): Promise<QuoteHeadingPreferences> => {
  return customFetch<QuoteHeadingPreferences>(getPatchQuoteHeadingNameUrl(), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(navigationHeadingNameEdit),
  });
};

export const getPatchQuoteHeadingNameMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchQuoteHeadingName>>,
    TError,
    { data: BodyType<NavigationHeadingNameEdit> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchQuoteHeadingName>>,
  TError,
  { data: BodyType<NavigationHeadingNameEdit> },
  TContext
> => {
  const mutationKey = ["patchQuoteHeadingName"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchQuoteHeadingName>>,
    { data: BodyType<NavigationHeadingNameEdit> }
  > = (props) => {
    const { data } = props ?? {};

    return patchQuoteHeadingName(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchQuoteHeadingNameMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchQuoteHeadingName>>
>;
export type PatchQuoteHeadingNameMutationBody =
  BodyType<NavigationHeadingNameEdit>;
export type PatchQuoteHeadingNameMutationError = ErrorType<void>;

/**
 * @summary Rename or reset one Cost Library navigation entry
 */
export const usePatchQuoteHeadingName = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchQuoteHeadingName>>,
    TError,
    { data: BodyType<NavigationHeadingNameEdit> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof patchQuoteHeadingName>>,
  TError,
  { data: BodyType<NavigationHeadingNameEdit> },
  TContext
> => {
  return useMutation(getPatchQuoteHeadingNameMutationOptions(options));
};

export const getGetQuoteHeadingPreferencesUrl = () => {
  return `/api/quote-heading-preferences`;
};

export const getQuoteHeadingPreferences = async (
  options?: RequestInit,
): Promise<QuoteHeadingPreferences> => {
  return customFetch<QuoteHeadingPreferences>(
    getGetQuoteHeadingPreferencesUrl(),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetQuoteHeadingPreferencesQueryKey = () => {
  return [`/api/quote-heading-preferences`] as const;
};

export const getGetQuoteHeadingPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getQuoteHeadingPreferences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteHeadingPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetQuoteHeadingPreferencesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getQuoteHeadingPreferences>>
  > = ({ signal }) => getQuoteHeadingPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteHeadingPreferences>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetQuoteHeadingPreferencesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getQuoteHeadingPreferences>>
>;
export type GetQuoteHeadingPreferencesQueryError = ErrorType<unknown>;

export function useGetQuoteHeadingPreferences<
  TData = Awaited<ReturnType<typeof getQuoteHeadingPreferences>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof getQuoteHeadingPreferences>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetQuoteHeadingPreferencesQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getSaveQuoteHeadingPreferencesUrl = () => {
  return `/api/quote-heading-preferences`;
};

export const saveQuoteHeadingPreferences = async (
  quoteHeadingPreferences: QuoteHeadingPreferences,
  options?: RequestInit,
): Promise<QuoteHeadingPreferences> => {
  return customFetch<QuoteHeadingPreferences>(
    getSaveQuoteHeadingPreferencesUrl(),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(quoteHeadingPreferences),
    },
  );
};

export const getSaveQuoteHeadingPreferencesMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveQuoteHeadingPreferences>>,
    TError,
    { data: BodyType<QuoteHeadingPreferences> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof saveQuoteHeadingPreferences>>,
  TError,
  { data: BodyType<QuoteHeadingPreferences> },
  TContext
> => {
  const mutationKey = ["saveQuoteHeadingPreferences"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof saveQuoteHeadingPreferences>>,
    { data: BodyType<QuoteHeadingPreferences> }
  > = (props) => {
    const { data } = props ?? {};

    return saveQuoteHeadingPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SaveQuoteHeadingPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof saveQuoteHeadingPreferences>>
>;
export type SaveQuoteHeadingPreferencesMutationBody =
  BodyType<QuoteHeadingPreferences>;
export type SaveQuoteHeadingPreferencesMutationError = ErrorType<unknown>;

export const useSaveQuoteHeadingPreferences = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof saveQuoteHeadingPreferences>>,
    TError,
    { data: BodyType<QuoteHeadingPreferences> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof saveQuoteHeadingPreferences>>,
  TError,
  { data: BodyType<QuoteHeadingPreferences> },
  TContext
> => {
  return useMutation(getSaveQuoteHeadingPreferencesMutationOptions(options));
};

/**
 * @summary Preview a builder subscription transfer (builder admins only)
 */
export const getPreviewSubscriptionTransferUrl = (id: string) => {
  return `/api/admin/users/${id}/subscription-transfer/preview`;
};

export const previewSubscriptionTransfer = async (
  id: string,
  subscriptionTransferDestination: SubscriptionTransferDestination,
  options?: RequestInit,
): Promise<SubscriptionTransferPreview> => {
  return customFetch<SubscriptionTransferPreview>(
    getPreviewSubscriptionTransferUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(subscriptionTransferDestination),
    },
  );
};

export const getPreviewSubscriptionTransferMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewSubscriptionTransfer>>,
    TError,
    { id: string; data: BodyType<SubscriptionTransferDestination> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof previewSubscriptionTransfer>>,
  TError,
  { id: string; data: BodyType<SubscriptionTransferDestination> },
  TContext
> => {
  const mutationKey = ["previewSubscriptionTransfer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof previewSubscriptionTransfer>>,
    { id: string; data: BodyType<SubscriptionTransferDestination> }
  > = (props) => {
    const { id, data } = props ?? {};

    return previewSubscriptionTransfer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PreviewSubscriptionTransferMutationResult = NonNullable<
  Awaited<ReturnType<typeof previewSubscriptionTransfer>>
>;
export type PreviewSubscriptionTransferMutationBody =
  BodyType<SubscriptionTransferDestination>;
export type PreviewSubscriptionTransferMutationError = ErrorType<void>;

/**
 * @summary Preview a builder subscription transfer (builder admins only)
 */
export const usePreviewSubscriptionTransfer = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof previewSubscriptionTransfer>>,
    TError,
    { id: string; data: BodyType<SubscriptionTransferDestination> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof previewSubscriptionTransfer>>,
  TError,
  { id: string; data: BodyType<SubscriptionTransferDestination> },
  TContext
> => {
  return useMutation(getPreviewSubscriptionTransferMutationOptions(options));
};

/**
 * @summary Move existing subscription ownership without new billing or moving quotes
 */
export const getTransferSubscriptionUrl = (id: string) => {
  return `/api/admin/users/${id}/subscription-transfer`;
};

export const transferSubscription = async (
  id: string,
  subscriptionTransferInput: SubscriptionTransferInput,
  options?: RequestInit,
): Promise<SubscriptionTransferResult> => {
  return customFetch<SubscriptionTransferResult>(
    getTransferSubscriptionUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(subscriptionTransferInput),
    },
  );
};

export const getTransferSubscriptionMutationOptions = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferSubscription>>,
    TError,
    { id: string; data: BodyType<SubscriptionTransferInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof transferSubscription>>,
  TError,
  { id: string; data: BodyType<SubscriptionTransferInput> },
  TContext
> => {
  const mutationKey = ["transferSubscription"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof transferSubscription>>,
    { id: string; data: BodyType<SubscriptionTransferInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return transferSubscription(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type TransferSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof transferSubscription>>
>;
export type TransferSubscriptionMutationBody =
  BodyType<SubscriptionTransferInput>;
export type TransferSubscriptionMutationError = ErrorType<void>;

/**
 * @summary Move existing subscription ownership without new billing or moving quotes
 */
export const useTransferSubscription = <
  TError = ErrorType<void>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof transferSubscription>>,
    TError,
    { id: string; data: BodyType<SubscriptionTransferInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof transferSubscription>>,
  TError,
  { id: string; data: BodyType<SubscriptionTransferInput> },
  TContext
> => {
  return useMutation(getTransferSubscriptionMutationOptions(options));
};

/**
 * Returns server health status
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Always returns the same generic response whether the address is unknown, throttled, or eligible.
 * @summary Request an email password reset link
 */
export const getRequestPasswordResetUrl = () => {
  return `/api/auth/password-reset/request`;
};

export const requestPasswordReset = async (
  passwordResetRequestInput: PasswordResetRequestInput,
  options?: RequestInit,
): Promise<PasswordResetMessage> => {
  return customFetch<PasswordResetMessage>(getRequestPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(passwordResetRequestInput),
  });
};

export const getRequestPasswordResetMutationOptions = <
  TError = ErrorType<PasswordResetMessage>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetRequestInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetRequestInput> },
  TContext
> => {
  const mutationKey = ["requestPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    { data: BodyType<PasswordResetRequestInput> }
  > = (props) => {
    const { data } = props ?? {};

    return requestPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestPasswordReset>>
>;
export type RequestPasswordResetMutationBody =
  BodyType<PasswordResetRequestInput>;
export type RequestPasswordResetMutationError = ErrorType<PasswordResetMessage>;

/**
 * @summary Request an email password reset link
 */
export const useRequestPasswordReset = <
  TError = ErrorType<PasswordResetMessage>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof requestPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetRequestInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof requestPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetRequestInput> },
  TContext
> => {
  return useMutation(getRequestPasswordResetMutationOptions(options));
};

/**
 * @summary Set a new password using a one-time reset token
 */
export const getConfirmPasswordResetUrl = () => {
  return `/api/auth/password-reset/confirm`;
};

export const confirmPasswordReset = async (
  passwordResetConfirmInput: PasswordResetConfirmInput,
  options?: RequestInit,
): Promise<PasswordResetMessage> => {
  return customFetch<PasswordResetMessage>(getConfirmPasswordResetUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(passwordResetConfirmInput),
  });
};

export const getConfirmPasswordResetMutationOptions = <
  TError = ErrorType<PasswordResetMessage>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetConfirmInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof confirmPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetConfirmInput> },
  TContext
> => {
  const mutationKey = ["confirmPasswordReset"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof confirmPasswordReset>>,
    { data: BodyType<PasswordResetConfirmInput> }
  > = (props) => {
    const { data } = props ?? {};

    return confirmPasswordReset(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ConfirmPasswordResetMutationResult = NonNullable<
  Awaited<ReturnType<typeof confirmPasswordReset>>
>;
export type ConfirmPasswordResetMutationBody =
  BodyType<PasswordResetConfirmInput>;
export type ConfirmPasswordResetMutationError = ErrorType<PasswordResetMessage>;

/**
 * @summary Set a new password using a one-time reset token
 */
export const useConfirmPasswordReset = <
  TError = ErrorType<PasswordResetMessage>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof confirmPasswordReset>>,
    TError,
    { data: BodyType<PasswordResetConfirmInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof confirmPasswordReset>>,
  TError,
  { data: BodyType<PasswordResetConfirmInput> },
  TContext
> => {
  return useMutation(getConfirmPasswordResetMutationOptions(options));
};

/**
 * @summary Send a direct email to a product user
 */
export const getSendAdminUserEmailUrl = (id: string) => {
  return `/api/admin/users/${id}/email`;
};

export const sendAdminUserEmail = async (
  id: string,
  adminMailComposeInput: AdminMailComposeInput,
  options?: RequestInit,
): Promise<AdminMailSendResponse | AdminMailError> => {
  return customFetch<AdminMailSendResponse | AdminMailError>(
    getSendAdminUserEmailUrl(id),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(adminMailComposeInput),
    },
  );
};

export const getSendAdminUserEmailMutationOptions = <
  TError = ErrorType<AdminMailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAdminUserEmail>>,
    TError,
    { id: string; data: BodyType<AdminMailComposeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendAdminUserEmail>>,
  TError,
  { id: string; data: BodyType<AdminMailComposeInput> },
  TContext
> => {
  const mutationKey = ["sendAdminUserEmail"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendAdminUserEmail>>,
    { id: string; data: BodyType<AdminMailComposeInput> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendAdminUserEmail(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendAdminUserEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendAdminUserEmail>>
>;
export type SendAdminUserEmailMutationBody = BodyType<AdminMailComposeInput>;
export type SendAdminUserEmailMutationError = ErrorType<AdminMailError>;

/**
 * @summary Send a direct email to a product user
 */
export const useSendAdminUserEmail = <
  TError = ErrorType<AdminMailError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendAdminUserEmail>>,
    TError,
    { id: string; data: BodyType<AdminMailComposeInput> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendAdminUserEmail>>,
  TError,
  { id: string; data: BodyType<AdminMailComposeInput> },
  TContext
> => {
  return useMutation(getSendAdminUserEmailMutationOptions(options));
};

/**
 * @summary List sent messages and customer replies for one product
 */
export const getGetAdminMailUrl = (params?: GetAdminMailParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/admin/mail?${stringifiedParams}`
    : `/api/admin/mail`;
};

export const getAdminMail = async (
  params?: GetAdminMailParams,
  options?: RequestInit,
): Promise<AdminMailListResponse> => {
  return customFetch<AdminMailListResponse>(getGetAdminMailUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetAdminMailQueryKey = (params?: GetAdminMailParams) => {
  return [`/api/admin/mail`, ...(params ? [params] : [])] as const;
};

export const getGetAdminMailQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminMail>>,
  TError = ErrorType<AdminMailError>,
>(
  params?: GetAdminMailParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminMail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminMailQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminMail>>> = ({
    signal,
  }) => getAdminMail(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminMail>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminMailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAdminMail>>
>;
export type GetAdminMailQueryError = ErrorType<AdminMailError>;

/**
 * @summary List sent messages and customer replies for one product
 */

export function useGetAdminMail<
  TData = Awaited<ReturnType<typeof getAdminMail>>,
  TError = ErrorType<AdminMailError>,
>(
  params?: GetAdminMailParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAdminMail>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAdminMailQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}
